import { createContext } from 'react';

export const PasswordVisibilityContext = createContext();
